import React, { Fragment } from "react";
class ErrorMessages extends React.Component {
  get errorMessageString() {
    const { form, name } = this.props;

    if (name && name.toString().includes(".")) {
      const splitedValue = name.split(".");
      return form.errors[splitedValue[0]][splitedValue[1]];
    }
    return form.errors[name];
  }

  render() {
    const { hasErrorForm, errorMessage, hasErrorMessage } = this.props;

    return (
      <Fragment>
        { hasErrorMessage &&
          <span className="error">
            <small>{errorMessage}</small>
          </span>
        }
        { hasErrorForm &&
          <span className="error">
            <small>{this.errorMessageString}</small>
          </span>
        }
      </Fragment>
    );
  }
}

export default ErrorMessages;
